import React from 'react';
import styles from './PriorityBadge.module.css';

export type Priority = 'Critical' | 'High' | 'Medium' | 'Low';

interface PriorityBadgeProps {
  priority: Priority;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  return (
    <span className={`${styles.badge} ${styles[priority.toLowerCase()]}`}>
      {priority}
    </span>
  );
};
